import React, { FC } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TextWithInfo from "@app/component/typography/TextWithInfo";

import styles from "./Card.module.scss";

const identity = (value: number) => String(value);

export interface CardProps {
  icon: IconDefinition;
  title: string;
  tooltip?: string;
  value: number;
  valueFormatter?: (value: number) => string;
}

const Card: FC<CardProps> = ({ icon, title, tooltip, value, valueFormatter = identity }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FontAwesomeIcon icon={icon} />
        <span>{title}</span>
      </div>
      <div className={styles.valueLine}>
        <span>{valueFormatter(value)}</span>
        {tooltip && <TextWithInfo info={tooltip} inline />}
      </div>
    </div>
  );
};

export default Card;
